import * as v from "valibot";
import { authUserDto } from "./auth.dto";

const emailAddress = v.pipe(v.string(), v.trim(), v.email("Enter a valid email address"), v.maxLength(254, "Enter a valid email address"));

const providerToken = v.pipe(v.string(), v.minLength(1), v.maxLength(4096));

const nextPath = v.optional(v.pipe(v.string(), v.maxLength(512)));

export const standaloneSignInResponse = {
  accessToken: v.string(),
  accessTokenExpiresAt: v.number(),
  refreshToken: v.string(),
  refreshTokenExpiresAt: v.number(),
  user: v.object(authUserDto),
  extra: v.optional(v.record(v.string(), v.unknown())),
};
export type StandaloneSignInResponse = v.InferOutput<v.ObjectSchema<typeof standaloneSignInResponse, undefined>>;

export const googleSignInRequest = {
  idToken: providerToken,
};
export type GoogleSignInRequest = v.InferOutput<v.ObjectSchema<typeof googleSignInRequest, undefined>>;

export const googleCodeSignInRequest = {
  code: providerToken,
  redirectUri: v.pipe(v.string(), v.url(), v.maxLength(512)),
};
export type GoogleCodeSignInRequest = v.InferOutput<v.ObjectSchema<typeof googleCodeSignInRequest, undefined>>;

export const appleSignInRequest = {
  identityToken: providerToken,
  authorizationCode: v.optional(v.pipe(v.string(), v.maxLength(1024))),
  fullName: v.optional(
    v.object({
      givenName: v.optional(v.nullable(v.string())),
      familyName: v.optional(v.nullable(v.string())),
    }),
  ),
};
export type AppleSignInRequest = v.InferOutput<v.ObjectSchema<typeof appleSignInRequest, undefined>>;

export const emailSignInStartRequest = {
  email: emailAddress,
  next: nextPath,
};
export type EmailSignInStartRequest = v.InferOutput<v.ObjectSchema<typeof emailSignInStartRequest, undefined>>;

export const emailSignInStartResponse = {
  success: v.boolean(),
};
export type EmailSignInStartResponse = v.InferOutput<v.ObjectSchema<typeof emailSignInStartResponse, undefined>>;

export const emailSignInVerifyRequest = {
  email: v.optional(emailAddress),
  code: v.optional(v.pipe(v.string(), v.trim(), v.regex(/^\d{6}$/, "Enter the 6-digit code"))),
  token: v.optional(v.pipe(v.string(), v.maxLength(256))),
};
export type EmailSignInVerifyRequest = v.InferOutput<v.ObjectSchema<typeof emailSignInVerifyRequest, undefined>>;

export const emailSignInLinkRequest = {
  token: v.pipe(v.string(), v.maxLength(256)),
  next: nextPath,
};
export type EmailSignInLinkRequest = v.InferOutput<v.ObjectSchema<typeof emailSignInLinkRequest, undefined>>;
